export default __webpack_public_path__ + "images/0e04c5cccacac68294589e849dca23b6.jpg";